import { useMutation, useQueryClient } from '@tanstack/react-query'
import { meetingKeys } from '@/entities/meeting'
import { apiDelete, apiPostVoid } from '@/shared/api'
import { toast } from '@/shared/ui/toast'

// Добавить сотрудников в круг встречи: до звонка это приглашение, у прошедшей —
// доступ к записи и расшифровке. Право — у любого из круга (проверяет бэк),
// поэтому UI не гейтит кнопку ролью.
export function useInviteEmployees(meetingId: string, past = false) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (subjects: string[]) =>
      apiPostVoid(`/meetings/${meetingId}/invitees`, { subjects }),
    onSuccess: () => {
      toast.success(past ? 'Доступ открыт' : 'Приглашение отправлено')
      void qc.invalidateQueries({ queryKey: meetingKeys.detail(meetingId) })
    },
    onError: () =>
      toast.error(past ? 'Не удалось открыть доступ' : 'Не удалось позвать сотрудника'),
  })
}

export function useUninviteEmployee(meetingId: string, past = false) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (subject: string) =>
      apiDelete(`/meetings/${meetingId}/invitees/${encodeURIComponent(subject)}`),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: meetingKeys.detail(meetingId) })
    },
    onError: () => toast.error(past ? 'Не удалось забрать доступ' : 'Не удалось снять приглашение'),
  })
}
